import React, { useEffect } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { useLocation } from '@reach/router'

const updaterHeader = ({ backgroundHexa }: RealEstateDataPageComponentData) => {
  const location = useLocation()
  useEffect(() => {
    console.log(location)
    let header = document.getElementById('header-6')
    setTimeout(() => {
      if (header) {
        console.log(backgroundHexa)
        console.log('Lo ejecuto')
        header.style.backgroundColor = backgroundHexa || '#000'
      }
    }, 1000)
  }, [location])

  return <div id="updater"></div>
}

export default updaterHeader
